var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"mb-0 justify-space-between pl-3"},[_c('v-list-item-content',{staticClass:"pl-2"},[_c('v-list-item-title',{staticClass:"text-h3"},[_c('v-img',{attrs:{"src":require('@/assets/logo.png')}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }